import client from '../client'

export const getDirectOfferInfoForBuyerKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/GetDirectOfferInformationForBuyer`

export async function getDirectOfferInfoForBuyer({ vehicleId }) {
  const params = new URLSearchParams({ vehicleId })

  return client(`${getDirectOfferInfoForBuyerKey}?${params}`)
}
